/**
 * Calculate dispatch date by adding working days (skipping weekends) to today.
 *
 * @param {number} workingDays — number of production/working days
 * @returns {{ short: string, long: string, date: Date }}
 *   short: "dd/mm" (for compact display)
 *   long:  "Fri 18 Apr" (for human-friendly display)
 *   date:  the raw Date object
 */
function getDispatchDate(workingDays) {
  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  const dispatch = new Date();
  let remaining = Number(workingDays);

  while (remaining > 0) {
    dispatch.setDate(dispatch.getDate() + 1);
    const dow = dispatch.getDay();
    if (dow !== 0 && dow !== 6) {
      remaining -= 1;
    }
  }

  const dd = String(dispatch.getDate()).padStart(2, '0');
  const mm = String(dispatch.getMonth() + 1).padStart(2, '0');

  return {
    short: `${dd}/${mm}`,
    long: `${days[dispatch.getDay()]} ${dispatch.getDate()} ${months[dispatch.getMonth()]}`,
    date: dispatch
  };
}

window.getDispatchDate = getDispatchDate;
